import React from "react";
import {Box, Flex, Text, Image} from "@chakra-ui/react";

export default function FolderCard({name, onNavigate, contextPath = ""}) {
  const displayName = name.endsWith("/") ? name.slice(0, -1) : name;

  return (
    <Box
      cursor="pointer"
      borderRadius="10px"
      overflow="hidden"
      border="1.5px solid"
      borderColor="rgba(0,0,0,0.06)"
      bg="white"
      transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
      boxShadow="0 1px 3px rgba(0,0,0,0.04)"
      _hover={{
        borderColor: "rgba(0,0,0,0.12)",
        transform: "translateY(-2px)",
        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
      }}
      onClick={() => onNavigate(name)}
      className="folder-card"
    >
      <Flex
        h="100px"
        bg="#f8f9fa"
        align="center"
        justify="center"
      >
        <Image
          src="/images/Doctor/folder.png"
          alt="folder"
          boxSize="44px"
          opacity={0.7}
          draggable={false}
          userSelect="none"
        />
      </Flex>
      <Box px={3} py={2.5} borderTop="1px solid" borderColor="rgba(0,0,0,0.04)">
        <Text
          fontSize="11.5px"
          fontWeight="600"
          color="gray.700"
          noOfLines={contextPath ? 1 : 2}
          lineHeight="1.4"
          title={displayName}
          wordBreak="break-word"
        >
          {displayName}
        </Text>
        {contextPath && (
          <Text
            mt={0.5}
            fontSize="10px"
            color="gray.500"
            noOfLines={1}
            title={contextPath}
          >
            {contextPath}
          </Text>
        )}
      </Box>
    </Box>
  );
}
